/**
 * Dealflow Deck API
 * API to by used by deck
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TestStatusEnum } from './test-status-enum';

export interface PatchedDeckInvestmentCompanyRequest {
  name?: string;
  red?: boolean;
  test_status?: TestStatusEnum;
}
export namespace PatchedDeckInvestmentCompanyRequest {}
